import { render } from "./App.vue?vue&type=template&id=efae6398"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=efae6398&lang=sass"
script.render = render

export default script